import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAuthLogin } from "../redux/slices/isAuth";

const useExpiredToken = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleExpired = () => {
    dispatch(
      setAuthLogin({ role: null, jwtToken: null, userId: null, fname: null })
    );
    navigate("/login");
  };

  return handleExpired;
};

export default useExpiredToken;
